import { sendGAEvent } from '../utils';

export enum BonusShopEvents {
  BONUS_SHOP_PROD_DETAILS_APPEARANCE = 'bonus_shop_prod_details_appearance',
  BONUS_SHOP_EXCHANGE_SUCCESS = 'bonus_shop_exchange_success',
  BONUS_SHOP_EXCHANGE_FAILURE = 'bonus_shop_exchange_failure',
}

const ERROR_MAX_LENGTH = 100;

export interface IBonusShopProductEvent {
  type: 'fs' | 'cash' | 'bonus_cash' | 'lootbox' | 'premium';
  bonus_id: string;
  fs_amount?: number;
  amount?: number;
  currency: string;
  cp_price: number;
}

interface IBonusShopDetailsEvent extends IBonusShopProductEvent {
  cp_balance?: number;
}

interface IBonusShopFailureEvent extends IBonusShopProductEvent {
  error: string;
}

export const sendBonusShopProdDetailsAppearanceEvent = (
  data: IBonusShopDetailsEvent
) => {
  sendGAEvent(BonusShopEvents.BONUS_SHOP_PROD_DETAILS_APPEARANCE, data);
};

export const sendBonusShopExchangeSuccessEvent = (
  data: IBonusShopProductEvent
) => {
  sendGAEvent(BonusShopEvents.BONUS_SHOP_EXCHANGE_SUCCESS, data);
};

export const sendBonusShopExchangeFailureEvent = (
  data: IBonusShopFailureEvent
) => {
  sendGAEvent(BonusShopEvents.BONUS_SHOP_EXCHANGE_FAILURE, {
    ...data,
    error: data.error.slice(0, ERROR_MAX_LENGTH),
  });
};
